import { render, staticRenderFns } from "./DepartmentCreate.vue?vue&type=template&id=f144bb8a&"
import script from "./DepartmentCreate.vue?vue&type=script&lang=js&"
export * from "./DepartmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports